var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-email")]),_c('b',[_vm._v("Email")])],1),_c('div',[_vm._v(_vm._s(_vm.email))])])}
var staticRenderFns = []

export { render, staticRenderFns }